var sw = sw || {};

// Form validation - registration
//----------------------------------------------------------
sw.formRegister = function() {
	var $form = $('#form-af');
	var $submitBtn = $form.bind('button.btn');

	if(!$form.length) {
		return;
	}

	$form.validate({
		rules: {
			"first_name": {
				required: true,
				minlength: 2,
			},
			"last_name": {
				required: true,
				minlength: 2,
			},
			"email": {
				required: true,
				email: true,
			},
			"consent": {
			    required: true,
			    minlength: 1
			},
		},

		errorPlacement: function(error, element) {
            element.closest('fieldset').append(error);
        },

        submitHandler: function(form) {
            $.ajax({
                url: form.action,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    //response = jQuery.parseJSON(response);
                	form.reset();
                	// alert(response.response);
                	$('.form__response').addClass('active');
                }           
            });

        }
	});
};


$(document).ready(function (){
	sw.formRegister();
});